<template>
  <div class="content">
    <div style="height: 175px">
      <img src="../../static/title.jpg" alt="" draggable="false" style="width: 100%;height: 175px;">
    </div>
    <div>
      <div style="background-color: #FFFFFF;">
        <div style="width: 100%; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b;">
          <div class="t-tr-sea" style="width: 90%; height: 165.33px; margin: auto; border-bottom: 1px solid rgb(204, 204, 204); --darkreader-inline-border-bottom: #3e4446;" v-for="(item, index) in items" :key="index">
            <div style="display: flex; margin-top: 7px;" class="about-hand">
              <div>
                <img :src="item.src" style="width: 150px; height: 140px;" alt="">
              </div>
              <div style="margin-bottom: 10px;">
                <div style="font-size: 15px;font-weight: 600; height: 27px; color: black">{{item.name}}</div>
                <div style="font-size: 15px;font-weight: 500; height: 27px; color: black">成色：{{item.quality}}</div>
                <div style="font-size: 15px;font-weight: 500; height: 27px; color: black">{{item.stock}}</div>
                <div style="font-size: 15px;font-weight: 500; height: 27px" :style="dynamicColor[item.name]">
                  金价：{{dynamicPrice[item.name]}}
                </div>
                <div><el-button type="primary" class="order" @click="handleOrder(item.name)"> 我要卖料</el-button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from '../common/eventBus'

export default {
  name: 'Sell',
  data () {
    return {
      items: {
        'TMAU': {
          src: require('../../static/hj.jpg'),
          name: '黄金板料',
          quality: '黄金',
          title: '成色：足金999',
          stock: '库存：9999'
        },
        'TMAP': {
          src: require('../../static/boj.jpg'),
          name: '铂金板料',
          quality: '铂金',
          title: '成色：铂金999',
          stock: '库存：9999'
        },
        'TMPD': {
          src: require('../../static/baj.jpg'),
          name: '钯金板料',
          quality: '钯金',
          title: '成色：钯金999',
          stock: '库存：9999'
        }
      },
      tableList: [],
      dynamicColor: {},
      dynamicPrice: {}
    }
  },
  created () {
    if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
      this.connectWebSocket()
    }
    EventBus.$on('tabListUpdated', updatedTabList => {
      this.tableList = updatedTabList
      this.updateDynamicData()
    })
    this.getUserInfo()
    localStorage.setItem('page', 'Sell')
    localStorage.removeItem('type')
    localStorage.removeItem('direction')
  },
  methods: {
    getUserInfo () {
      this.$api.userInfo().then(response => {
        if (response.code === 200) {
          this.userInfo = response.data
          this.orderParams.amount = parseInt(this.orderParams.goldWeight) * parseInt(this.userInfo.goldDepositRate)
        } else {
          this.msgError(response.msg)
        }
      })
    },
    updateDynamicData () {
      this.dynamicColor = {
        '黄金板料': this.handleColor('足金板料'),
        '钯金板料': this.handleColor('钯金板料'),
        '铂金板料': this.handleColor('铂金板料')
      }
      this.dynamicPrice = {
        '黄金板料': this.handlePrice('足金板料'),
        '钯金板料': this.handlePrice('钯金板料'),
        '铂金板料': this.handlePrice('铂金板料')
      }
    },
    handleColor (type) {
      let color = ''
      let price = ''
      let maxPrice = ''
      let minPrice = ''
      if (!this.tableList) {
        return color
      }
      switch (type) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            price = parseFloat(this.tableList['GOLD'].Sell)
            minPrice = parseFloat(this.tableList['GOLD'].L)
            maxPrice = parseFloat(this.tableList['GOLD'].H)
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            price = parseFloat(this.tableList['PALLADIUM'].Sell)
            minPrice = parseFloat(this.tableList['PALLADIUM'].L)
            maxPrice = parseFloat(this.tableList['PALLADIUM'].H)
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            price = parseFloat(this.tableList['PLATINUM'].Sell)
            minPrice = parseFloat(this.tableList['PLATINUM'].L)
            maxPrice = parseFloat(this.tableList['PLATINUM'].H)
          }
          break
      }
      let mean = (minPrice + maxPrice) / 2
      color = price > mean ? 'color:#FF0000' : 'color:#0f0'
      if (price === mean) color = ''
      return color
    },
    handlePrice (type) {
      let price = ''
      if (!this.tableList) {
        return '--'
      }
      switch (type) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            price = parseFloat(this.tableList['GOLD'].Buy)
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            price = parseFloat(this.tableList['PALLADIUM'].Buy)
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            price = parseFloat(this.tableList['PLATINUM'].Buy)
          }
          break
      }
      return parseFloat(price) ? parseFloat(price).toFixed(2) : '--'
    },
    handleOrder (type) {
      localStorage.setItem('type', type)
      localStorage.setItem('direction', 'Sell')
      this.$router.push({ name: 'Order' })
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 100vh;
  background-color: white;
}

.t-tr-sea {
  display: flex;
  width: 100%;
  margin: auto;
}

.t-tr-sea .t-td:first-child {
  width: 28% !important;
}

.t-tr-sea .t-td {
  font-size: 32px;
  width: 24% !important;
  font-family: PingFang SC,serif;
  border-top: none !important;
  border-bottom: none !important;
  margin-left: -2px;
  text-align: center !important;
}

.about-hand {
  display: flex;
  border-bottom: 1px solid #f3f3f3;
}

.about-hand>div:first-child {
  margin: 0 30px;
}

.order {
  background-color: #43d67b;
  color: #FFFFFF;
  font-size: 15px;
  width: 100px;
  margin: 0 0 0 0;
  border-color: transparent;
  box-shadow: none;
  outline: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Sell.vue